import { NotFoundDoorAndConfusedPenguin } from "@illustrations";

import { ErrorDisplay } from "./error-display";

interface NotFoundErrorPropType {
  message?: string;
}

export default function NotFoundError({ message }: NotFoundErrorPropType) {
  return (
    <ErrorDisplay
      message={message}
      defaultTranslationKey="notFound"
      Illustration={<NotFoundDoorAndConfusedPenguin />}
    />
  );
}
